import { Editor } from '@tiptap/react'
import { useMemo } from 'react'

import StrikeIcon from '~icons/editor/font_s.svg'
import UnderlineIcon from '~icons/editor/font_u.svg'
import BoldIcon from '~icons/editor/fontbold.svg'
import ItalicIcon from '~icons/editor/fontitalic.svg'
import { capitalize } from '~lib/textFormat'

export enum MARK {
  Bold = 'bold',
  Italic = 'italic',
  Strike = 'strike',
  Underline = 'underline',
}

export interface IMark {
  name: MARK
  label: string
  icon: JSX.Element
}

const marks: IMark[] = [
  {
    name: MARK.Bold,
    label: capitalize(MARK.Bold),
    icon: <BoldIcon />,
  },
  {
    name: MARK.Italic,
    label: capitalize(MARK.Italic),
    icon: <ItalicIcon />,
  },
  {
    name: MARK.Underline,
    label: capitalize(MARK.Underline),
    icon: <UnderlineIcon />,
  },
  {
    name: MARK.Strike,
    label: capitalize(MARK.Strike),
    icon: <StrikeIcon />,
  },
]

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useMarks = (editor: Editor) => {
  return useMemo(
    () => ({
      marks,
      toggleMark: (name) => {
        const commandName = `toggle${capitalize(name)}`
        editor.chain().focus()[commandName]().run()
      },
      isActive: (name) => editor.isActive(name),
    }),
    [editor]
  )
}
